<template>
  <div>
    <report-tabs :tabs="tabs" :options="processedOptions">
      <template slot="settings">
        <div class="mx-3">
          <cool-label>Date Range</cool-label>
          <date-picker :date="options.date" :timezone="options.timezone" @timeZoneChange="options.timezone = $event"></date-picker>
        </div>
        <div v-if="baseField === 'exchange'" class="mx-3">
          <cool-label>Select Exchange</cool-label>
          <populating-filter-dropdown field="exchange" v-model="options.filter.value" :date="options.date" placeholder="Select exchange"></populating-filter-dropdown>
        </div>
        <div v-else-if="baseField === 'med_name'" class="mx-3">
          <cool-label>Select Medium</cool-label>
          <populating-filter-dropdown field="med_name" v-model="options.filter.value" :date="options.date" placeholder="Select medium"></populating-filter-dropdown>
        </div>
        <div v-else-if="baseField === 'pub_name'" class="mx-3">
          <cool-label>Select Publisher</cool-label>
          <populating-filter-dropdown field="pub_name" v-model="options.filter.value" :date="options.date" placeholder="Select publisher"></populating-filter-dropdown>
        </div>
      </template>
    </report-tabs>
  </div>
</template>

<script>
import ReportTabs from '@/reports/components/ReportTabs'
import MapsView from '@/reports/components/User/MapsView'
import JourneyView from '@/reports/components/User/JourneyView'
import UserOverview from '@/reports/components/User/UserOverview'
import DatePicker from '@/components/DatePicker'
import PopulatingFilterDropdown from '@/reports/components/PopulatingFilterDropdown'
import { ReportsApi } from '@/reports/api'
import { getSuggestedInterval, isExchangeView, getBasePublisherField } from '@/reports/components/ReportUtils'


import moment from 'moment'

export default {
  props: {
    publisherId: { type: String, required: false },
    partnerId: { type: String, required: false }
  },
  data() {
    return {
      //options is the options that the user sets in the top bar
      //it should never be used to actually pull a report
      options: {
        timezone: 'UTC',
        date: {
          start: moment().utc().startOf('day').valueOf(),
          end: moment().utc().startOf('day').valueOf()
        },
        filter: {
          field: '',
          operator: 'EQUAL',
          value: ''
        },
        filters: [],
      },
      tabs: [],
      currentTab: 0,
      perPage: 10,
    }
  },
  created () {
    this.options.filter.field = this.baseField

    if (isExchangeView(this)) {
      this.tabs = [{ tabName: 'Location', component: MapsView }]
    } else {
      this.tabs = [
        { tabName: 'Overview', component: UserOverview },
        { tabName: 'Location', component: MapsView },
        { tabName: 'Journey', component: JourneyView },
      ]
    }
  },
  computed: {
    baseField () {
      return getBasePublisherField(this)
    },
    processedOptions () {
      let options = JSON.parse(JSON.stringify(this.options))
      options.startTime = options.date.start
      options.endTime = options.date.end
      delete options.date

      if (options.filter.value.length > 0) {
        options.filters.push(options.filter)
      }
      delete options.filter

      if (this.publisherId !== undefined) {
        options.filters.push({ field: 'pub_id', operator: 'EQUAL', value: String(this.publisherId) })
      }
      if (this.partnerId !== undefined) {
        options.filters.push({ field: 'bidder_id', operator: 'EQUAL', value: String(this.partnerId) })
      }

      return options
    },
  },
  components: {
    ReportTabs,
    DatePicker,
    PopulatingFilterDropdown
  }
}
</script>


// WEBPACK FOOTER //
// src/reports/pages/User.vue